import { Overrides } from '@material-ui/core/styles/overrides';

import { CORPORATE_COLORS } from '../colors/corporate';

export const formOverrides: Overrides = {
  MuiInputBase: {
    root: {
      color: CORPORATE_COLORS.TEXT_PRIMARY
    }
  },
  MuiInputLabel: {
    root: {
      color: CORPORATE_COLORS.CONTENT_DARK_PRIMARY_LOW,
      paddingLeft: '24px',
      zIndex: 1,
      '@media (max-width:600px)': {
        paddingLeft: '16px'
      },
      '&.Mui-error': {
        color: CORPORATE_COLORS.RED
      }
    },
    formControl: {
      transform: 'translate(0, 20px) scale(1)'
    },
    shrink: {
      top: 0,
      paddingTop: '8px',
      paddingLeft: '36px',
      color: CORPORATE_COLORS.CONTENT_DARK_PRIMARY_LOW
    }
  },
  MuiOutlinedInput: {
    root: {
      backgroundColor: CORPORATE_COLORS.WHITE,
      borderRadius: '36px',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: CORPORATE_COLORS.CONTENT_DARK_PRIMARY_LOW
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: CORPORATE_COLORS.PRIMARY
      },
      border: '1px solid',
      borderColor: CORPORATE_COLORS.BACKGROUND_LIGHT_PRIMARY_HIGH,
      '&:hover': {
        borderColor: CORPORATE_COLORS.BACKGROUND_LIGHT_PRIMARY_MAX
      },
      "&[aria-expanded='true']": {
        borderRadius: '36px 36px 0px 0px',
        borderBottom: 0
      }
    },
    input: {
      padding: '16px'
    },
    notchedOutline: {
      borderColor: CORPORATE_COLORS.BACKGROUND_LIGHT_PRIMARY_HIGH,
      border: '0 !important'
    }
  },
  MuiFormLabel: {
    root: {
      fontSize: '16px',
      '@media (max-width:600px)': {
        fontSize: '14px'
      },
      '&.Mui-focused': {
        color: CORPORATE_COLORS.CONTENT_DARK_PRIMARY_LOW
      }
    }
  },
  MuiMenu: {
    paper: {
      marginLeft: '-1px',
      borderRadius: '0pc 0pc 36px 36px',
      transitionDuration: '0s !important'
    },
    list: {
      color: CORPORATE_COLORS.TEXT_PRIMARY
    }
  },
  MuiMenuItem: { root: { padding: '0 20px' } },
  MuiList: {
    padding: { paddingTop: 0, paddingBottom: 0 }
  }
};
